import { useCallback } from "react";
import useShowPDF from "@util/hook/useShowPDF";
import { objectToQueryString } from "@util/utils";
import {
	GET_DOCUMENT_LEADERBOARD_POSTER_API,
	GET_DOCUMENT_TRANSCRIPT_API,
	GET_DOCUMENT_MEASURE_SPORT_ADVISE_API,
	GET_DOCUMENT_MULTIPLE_MEASURE_INFORMATION_API,
	GET_DOCUMENT_EVALUATION_API,
	GET_PAYMENT_CREDIT_CARD_PDF_API,
} from "@apis/apiPath";

const useDocumentApi = () => {
	const showPDF = useShowPDF();

    // 信用卡授權書
	const getPaymentCreditCardPDFApi = async () => {
		showPDF({
			open: true,
			pdfUrl: GET_PAYMENT_CREDIT_CARD_PDF_API,
		});
	};

	const getLeaderboardPDFApi = useCallback(
		async params => {
			const path = `${GET_DOCUMENT_LEADERBOARD_POSTER_API}?${params}`;
			showPDF({
				open: true,
				htmlUrl: path,
				pdfUrl: path,
			});
		},
		// eslint-disable-next-line
		[]
	);

	// 成績單
	const getTranscriptPDFApi = useCallback(
		async (params, key, memberID) => {
			const path = `${GET_DOCUMENT_TRANSCRIPT_API(key)}${params}`;
			const pdfParams = {
				open: true,
				htmlUrl: path,
				pdfUrl: path,
				canDownload: false,
				canPrint: false,
				canQrCode: false,
				sourceData: { memberID },
			};
			showPDF(pdfParams);
		},
		// eslint-disable-next-line
		[]
	);

	// 綜合評估表
	const getEvaluationPDFApi = useCallback(
		async (params, key, memberID) => {
			const path = `${GET_DOCUMENT_EVALUATION_API(key)}${params}`;
			const pdfParams = {
				open: true,
				htmlUrl: path,
				pdfUrl: path,
				canDownload: false,
				canPrint: false,
				canQrCode: false,
				sourceData: { memberID },
			};
			showPDF(pdfParams);
		},
		// eslint-disable-next-line
		[]
	);

	// 取得健康指引
	const getSportAdvisePDFApi = useCallback(
		async (measureID, healthDeclarationContractID) => {
			const path = `${GET_DOCUMENT_MEASURE_SPORT_ADVISE_API(measureID)}${objectToQueryString(healthDeclarationContractID)}`;
			showPDF({
				open: true,
				htmlUrl: path,
				pdfUrl: path,
				canDownload: false,
				canPrint: false,
			});
		},
		// eslint-disable-next-line
		[]
	);

	// 成績單與套表混合頁面
	const getMultipleInformationApi = useCallback(
		async (params, key, memberID) => {
			const path = `${GET_DOCUMENT_MULTIPLE_MEASURE_INFORMATION_API(key)}${params}`;
			showPDF({
				open: true,
				htmlUrl: path,
				pdfUrl: path,
				canDownload: false,
				canPrint: false,
				canQrCode: false,
				sourceData: { memberID },
			});
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getPaymentCreditCardPDFApi,
		getLeaderboardPDFApi,
		getSportAdvisePDFApi,
		getTranscriptPDFApi,
		getEvaluationPDFApi,
		getMultipleInformationApi,
	};
};

export default useDocumentApi;
